import BaseDataObject from './BaseDataObject';
import HorseInfo from './HorseInfo';

export default class HorseInfoSet extends BaseDataObject {
  constructor(data) {
    super(
      Array.isArray(data)
        ? {
            horseInfo: data,
          }
        : data,
    );
  }

  getHorseInfo(startNumber) {
    const count = this.getNumberOf('jokerHorseInfos');

    for (let n = 0; n < count; n++) {
      const horseInfo = this.getObject('jokerHorseInfos', HorseInfo, n);

      if (horseInfo.getStartNumber() === startNumber) {
        return horseInfo;
      }
    }

    return null;
  }

  getHorseInfos() {
    return this.getObjects('jokerHorseInfos', HorseInfo);
  }

  getCommentsPublishDate() {
    return this.getDate('commentsPublishDate');
  }

  getIsLoggedIn() {
    return this.getBoolean('isLoggedIn');
  }

  getSKU() {
    return this.getString('sku');
  }
}
